import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { MyGuestQuizReport, MyHostQuizReport } from 'src/app/interfaces/quiz';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RouterService } from 'src/app/services/router/router.service';
import { HostQuizReportSelectorComponent } from '../../modals/quiz-report-selector/host-quiz-report-selector/host-quiz-report-selector.component';
import { GuestQuizReportSelectorComponent } from './../../modals/quiz-report-selector/guest-quiz-report-selector/guest-quiz-report-selector.component';
import { SelectGuestQuizReport, SelectHostQuizReport, SelectQuizReport } from './select-quiz-report';

export type SelectQuizReportType = 'host' | 'guest';

@Component({
  selector: 'app-select-quiz-report',
  templateUrl: './select-quiz-report.component.html',
  styleUrls: ['./select-quiz-report.component.scss'],
})
export class SelectQuizReportComponent implements OnChanges, OnDestroy {

  @Input() type: SelectQuizReportType = 'host';
  @Input() hideButton = false;
  @Input() hideModalButton = false;
  @Input() onClickReSelect = false; // true일 경우, 클릭시 재선택하도록. 아닐경우 detail 화면으로 이동
  @Output() selected = new EventEmitter<MyHostQuizReport | MyGuestQuizReport>();

  selectedQuizReport: MyHostQuizReport | MyGuestQuizReport | undefined;
  selectQuizReport: SelectQuizReport = this.selectQuizReportFactory();

  constructor(
    private modalService: ModalService,
    private routerService: RouterService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('type')) {
      this.selectQuizReport = this.selectQuizReportFactory();
      this.selectQuizReport.setInitialState();
    }
  }

  ngOnDestroy(): void {
    this.selectQuizReport.onDestroy();
  }

  async openSelectQuizReportModal(): Promise<void> {
    let modalComponent: any = HostQuizReportSelectorComponent;
    if (this.type === 'guest') {
      modalComponent = GuestQuizReportSelectorComponent;
    }
    const quizSelectModal: HTMLIonModalElement = await this.modalService.openBottomSheet(modalComponent, this.modalProps());
    await quizSelectModal.present();
    const { data } = await quizSelectModal.onWillDismiss();
    if (data !== undefined) {
      this.onSelectedQuizReport(data);
    }
  }

  navigateToDetail(): void {
    if (this.onClickReSelect) {
      this.openSelectQuizReportModal();
      return;
    }
    if (this.selectedQuizReport !== undefined) {
      this.routerService.navigate(`quiz/report/${this.selectedQuizReport.id}`);
    }
  }

  private modalProps(): { [key: string]: any } {
    let title = '';
    let description = '';
    switch (this.type) {
      case 'host':
        title = '성격 유형 퀴즈 선택';
      case 'guest':
        title = '응답 기록 선택';
    }
    return {
      title, description,
      type: this.type,
      hideButton: this.hideModalButton
    }
  }

  /**
   * 퀴즈리포트 선택시 처리 함수 
   */
  private onSelectedQuizReport(data: MyHostQuizReport | MyGuestQuizReport | undefined): void {
    if (data !== undefined && data !== null) {
      this.selectQuizReport.onSelectedQuizReport(data);
      this.selectedQuizReport = data;
      this.selected.emit(data);
    }
  }

  private selectQuizReportFactory(): SelectQuizReport {
    switch (this.type) {
      case 'guest':
        return new SelectGuestQuizReport();
      case 'host':
      default:
        return new SelectHostQuizReport();
    }
  }
}

